export default "__VITE_ASSET__b7bf6561__"